import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { SBHorizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { HeadlineS, LabelS } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_SERIES_SQUAD } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { JoinSecretShare } from './JoinSecretShare';

const Root = styled(Vertical)`
  position: relative;
  z-index: 1;
  width: 100%;
  padding: var(--double-unit);
`;

const Card = styled(Vertical)`
  border: 1px solid var(--c-nd-150);
  border-radius: var(--double-unit);
  padding: var(--double-unit);
  width: 100%;
`;

type Props = {
  joinSecret: string;
  membersCount: number;
  maxMembersCount: number;
};

export const SquadInviteBlock = ({
  joinSecret,
  membersCount,
  maxMembersCount,
}: Props) => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Root gap={2}>
      <SBHorizontal>
        <HeadlineS>
          <FormattedMessage defaultMessage="Invite your friends" />
        </HeadlineS>
        <LabelS color="var(--c-nd-600)">
          <FormattedMessage
            defaultMessage="({membersCount}/{max})"
            values={{ membersCount, max: maxMembersCount }}
          />
        </LabelS>
      </SBHorizontal>
      <Card gap={2}>
        <JoinSecretShare joinSecret={joinSecret} />
        <Button
          size="large"
          color="primary"
          to={generateSportContextPath(ANY_SPORT_SERIES_SQUAD)}
          fullWidth
        >
          <FormattedMessage defaultMessage="Continue" />
        </Button>
      </Card>
    </Root>
  );
};
